import { Box, IconButton,useTheme } from "@mui/material";
import { FunctionComponent } from "react";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import "./ArrowButton.css"

interface ArrowButtonProps {
    className?:string,
    onClick?:()=>any,
    hide?:boolean,
}
 
const ArrowButton: FunctionComponent<ArrowButtonProps> = (props) => {
    const {className,onClick,hide} = props;
    const theme = useTheme();
    if(hide) return <></>;
    return <Box id="ArrowButton" className={className}><IconButton className="iconButton" onClick={onClick}><ArrowBackIosNewIcon className="icon"/></IconButton></Box>;
}
 
export default ArrowButton;